<template>
  <div id="app" :class="$route.meta.navShow ? 'footShow' : ''">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <keep-alive> -->
    <!-- <router-view v-if="isRouterAlive"></router-view> -->
    <keep-alive v-if="!removeKeepAlive">
      <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
    <!-- </keep-alive> -->
    <tabbar v-if="$route.meta.navShow"></tabbar>
    <watermark :text="computedUserWatermark" v-if="computedWatermarkShow" />
  </div>
</template>

<script>
import tabbar from "@/components/tabbar";
import watermark from "@/components/watermark.vue";
export default {
  name: "App",
  components: {
    tabbar,
    watermark
  },
  mounted() {
    this.getUserInfo();
  },
  provide() {
    return {
      reload: this.reload,
      getUserInfo: this.getUserInfo,
      getCompanyConfig: this.getCompanyConfig
    };
  },
  data() {
    return {
      isRouterAlive: true,
      removeKeepAlive: false,
      userDetailInfo: {},
      isShowAppletGoodsPageWatermark: false
    };
  },
  computed: {
    computedUserWatermark() {
      return "" + this.userDetailInfo.businessName + this.userDetailInfo.custNo;
    },
    computedWatermarkShow() {
      const arr = [
        "classify",
        "commodyList",
        "commody",
        "goods",
        "goodsDetail",
        "brandClassify"
      ];
      const arrDock = [
        "classify",
        "classify_alone",
        "commodyList",
        "commody",
        "goods_alone",
        "goodsDetail",
        "brandClassify_alone",
        "commodyList_alone",
        "bucket",
        "bucket_alone"
      ];
      let isDock = true;
      if (Object.keys(this.userDetailInfo).length > 0) {
        isDock = this.userDetailInfo.isDock;
      }
      if (isDock) {
        return (
          this.$store.state.sysConfig.isShowAppletGoodsPageWatermark &&
          arr.includes(this.$route.name) &&
          Object.keys(this.userDetailInfo).length
        );
      } else {
        return (
          this.isShowAppletGoodsPageWatermark &&
          arrDock.includes(this.$route.name) &&
          Object.keys(this.userDetailInfo).length
        );
      }
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    async getUserInfo() {
      this.userDetailInfo = (await this.$api.common.getUser()) || {};
      if (
        Object.keys(this.userDetailInfo).length > 0 &&
        !this.userDetailInfo.isDock
      ) {
        this.getCompanyConfig();
      }
    },
    //获取系统配置
    getCompanyConfig() {
      var params = { companyId: this.userDetailInfo.companyId };
      this.$api.bucket.getCompanyConfig(params).then(res => {
        var result = res.data;
        if (result.status == 200) {
          this.isShowAppletGoodsPageWatermark =
            result.data.isShowAppletGoodsPageWatermark || false;
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      let token = localStorage.getItem("removeKeepAlive");
      token ? (this.removeKeepAlive = true) : (this.removeKeepAlive = false);
    }
  }
};
</script>

<style lang="scss">
@import "./assets/reset.scss";
#app {
  overflow: hidden;
  background-color: #f5f5f5;
}
.footShow {
  padding-bottom: 1.306667rem;
}
#app::-webkit-scrollbar {
  display: none;
  width: 0;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
}
.isHave {
  opacity: 0.4;
}
.shortpage {
  position: absolute;
  top: 0.2rem;
  right: 0.1rem;
  color: #fff;
  font-size: 0.36rem;
  padding: 0.05rem 0.2rem;
  border-radius: 0.4rem;
  background-color: rgb(126, 123, 123);
}
.hadAdd {
  position: absolute;
  z-index: 98;
  right: 0;
  top: 0;
  width: 1.2rem;
  height: 1.2rem;
  img {
    margin-top: 0 !important;
    width: 100% !important;
    height: 100% !important;
    padding-left: 0 !important;
  }
}
.activityStyle {
  position: absolute;
  top: $fz20;
  left: $fz20;
  padding: 0.05rem 0.2rem;
  border-radius: 0.4rem;
  background-color: #ff2d4a;
  color: #fff;
  z-index: 99;
}
.mescroll-totop {
  right: 0.426667rem;
  bottom: 90px !important;
  width: 42px;
  height: 42px;
}

.thounds {
  font-size: $fz30;
}
.mint-checkbox-input:checked + .mint-checkbox-core {
  background-color: #ff2d4a !important;
  border-color: #ff2d4a !important;
}
.toastZindex {
  z-index: 10001 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue